import { KeyboardEvent, useState, useEffect, ChangeEvent } from 'react';
import { plusWhite, searchIcoWhite } from 'assets/images';
import Button from 'components/forms/button';
import { InputText } from 'components/inputs';
import PageTitle from 'components/page-title';
import {
	fetchLeadsAsync, getLeadsData, getLeadsFilter, setLeadsFilter,
} from 'store/leads';
import { LEADS_FILTER_DEFAULT } from 'utils/constants/default-filters';
import { Dictionary } from 'utils/constants/dictionary';
import { useAppDispatch, useAppSelector, useWindow } from 'utils/hooks';
import LeadStatusMultipleSelect from './lead-status-multiple-select';
import LeadsStatusSorting from './leads-status-sorting';
import LeadBaseTable from './leads-table';
import NewLeadModal from './new-lead-modal';
import './Leads.scss';

const Leads = (): JSX.Element => {
	const dispatch = useAppDispatch();
	const leads = useAppSelector(getLeadsData);
	const filter = useAppSelector(getLeadsFilter);

	const [search, setSearch] = useState<string>(filter.search);

	const [newLeadModal, showNewLeadModal, hideNewLeadModal] = useWindow();

	const submitSearchFilter = (search: string)=> {
		dispatch(setLeadsFilter({ ...filter, search }));
	};

	const handleChange = (e: ChangeEvent<HTMLInputElement>): void => {
		if (e.target.value === '') {
			dispatch(setLeadsFilter({ ...filter, search: '' }));
		}
		setSearch(e.target.value);
	};

	const handlePressEnter = (e: KeyboardEvent<HTMLInputElement>): void => {
		dispatch(setLeadsFilter({ ...filter, search: e.currentTarget.value }));
	};

	useEffect(() => {
		dispatch(fetchLeadsAsync(filter));
	}, [dispatch, filter]);

	useEffect(() => () => {
		dispatch(setLeadsFilter(LEADS_FILTER_DEFAULT));
	}, [dispatch]);

	return (
		<div className="leads">
			<div className="leads__top">
				<PageTitle defaultText="Leads base" textId={Dictionary.leads.title} />

				<div className="leads__top-right">
					<div className="leads__top-search">
						<InputText
							defaultPlaceholder="Search"
							onChange={handleChange}
							onPressEnter={handlePressEnter}
							placeholderId={Dictionary.common.search}
							suffix={<button onClick={() => submitSearchFilter(search)}>
								<img alt="" src={searchIcoWhite} />
							</button>}
						/>
					</div>

					<div className="leads__top-statuses">
						<LeadStatusMultipleSelect />
					</div>

					<div className="leads__top-sort">
						<LeadsStatusSorting />
					</div>

					<Button
						className="new-lead-btn"
						defaultText="Add new lead"
						imgSrc={plusWhite}
						onClick={showNewLeadModal}
						textId={Dictionary.leads.addNewLead}
					/>
				</div>
			</div>

			<LeadBaseTable dataSource={leads} />

			{newLeadModal && <NewLeadModal onClose={hideNewLeadModal} />}
		</div>
	);
};

export default Leads;

